import { apiClient } from './client';

/** Valor efectivo de `ndvi.enabled` (cascada empresa → rancho). */
export interface NdviSettings {
  tenantEnabled: boolean;
  ranchos: Record<string, boolean>;
}

export const fetchNdviSettings = async (): Promise<NdviSettings> =>
  (await apiClient.get('/api/ndvi/settings')).data;

/** ¿El error del backend es el 403 `ndvi_disabled` (NDVI apagado para ese rancho)? */
export function isNdviDisabledError(err: unknown): boolean {
  const e = err as { response?: { status?: number; data?: { code?: string } } } | null | undefined;
  return e?.response?.status === 403 && e?.response?.data?.code === 'ndvi_disabled';
}
